import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addTOCFailure,
  //
  addTOCSuccess,
  deleteTOCFailure,
  //
  deleteTOCSuccess,
  editTOCFailure,
  //
  editTOCSuccess,
  fetchTOC as fetchTOCAction,
  fetchTOCFailure,
  fetchTOCSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_TOC,
  DELETE_TOC,
  EDIT_TOC,
  FETCH_TOC,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchTOCSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/type-of-care?${query}`);
    yield put(fetchTOCSuccess(data));
  } catch (e) {
    yield put(fetchTOCFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care type list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/type-of-care/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care type!"));
  }
}

export function* addTOCSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/type-of-care/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Care type added successfully!"));
      yield put(addTOCSuccess());
      if (payload?.history) {
        payload.history.push("/d/care-types");
      }
    }
  } catch (e) {
    yield put(addTOCFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editTOCSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/type-of-care/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Care type updated successfully!"));
      yield put(editTOCSuccess());
      yield put(getViewDataAction(payload.data.id));
    }
  } catch (e) {
    yield put(editTOCFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteTOCSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/type-of-care/${payload}`);
    if (data) {
      yield put(successAlert("Care type deleted successfully!"));
      yield put(deleteTOCSuccess());
      yield put(fetchTOCAction());
    }
  } catch (e) {
    yield put(deleteTOCFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchTOCFlow() {
  yield takeEvery(FETCH_TOC, fetchTOCSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addTOCFlow() {
  yield takeEvery(ADD_TOC, addTOCSaga);
}
export function* editTOCFlow() {
  yield takeEvery(EDIT_TOC, editTOCSaga);
}
export function* deleteTOCFlow() {
  yield takeEvery(DELETE_TOC, deleteTOCSaga);
}

export default function* TOCSaga() {
  yield all([
    fetchTOCFlow(),
    addTOCFlow(),
    editTOCFlow(),
    deleteTOCFlow(),
    getViewDataFlow(),
  ]);
}
